// import Vue from "vue";
// import VueRouter from "vue-router";

Vue.use(VueRouter);

export default new VueRouter({
  routes: [
    {
      path: "/",
      name: "Deposit",
      component: () => import("@/components/common/Loading"),
      meta: { layoutLv: 0, heightType: "common", name: "" }
    },
    {
      path: "/ke",
      name: "keDeposit",
      component: () => import("@/components/KeDeposit"),
      meta: { layoutLv: 0, heightType: "common", name: "Deposit" }
    },
    {
      path: "/payResult",
      name: "payResult",
      component: () => import("@/components/KeDeposit/payResult"),
      meta: { name: "Deposit" }
    },
    {
      path: "/GhDeposit",
      path: "/gh",
      name: "GhDeposit",
      component: () => import("@/components/GhDeposit"),
      meta: { layoutLv: 0, heightType: "common", name: "Deposit" }
    },
    {
      path: "/result",
      name: "result",
      component: () => import("@/components/common/DepositResult"),
      meta: { layoutLv: 0, heightType: "common", name: "Deposit" }
    },
    {
      path: '/ug',
      name: 'UgDeposit',
      component: () => import("@/components/UgDeposit"),
      meta: { layoutLv: 0, heightType: "common", name: "Deposit" }
    },
    {
      path: "/ng",
      name: "Deposit",
      component: () => import("@/components/NgDeposit"),
      meta: { layoutLv: 0, heightType: "common", name: "Deposit" }
    },
    {
      path: "/changeMethods",
      name: "changeModal",
      component: () => import("@/components/NgDeposit/changeModal/index.vue"),
      meta: { layoutLv: 1, heightType: "common", name: "Deposit" }
    },
    {
      path: "/keWithdraw",
      name: "keWithdraw",
      component: () => import("@/components/KeWithdraw"),
      meta: { layoutLv: 0, heightType: "common", name: "Withdraw" }
    },
    {
      path: "/ngWithdraw",
      name: "ngWithdraw",
      component: () => import("@/components/NgWithdraw"),
      meta: { layoutLv: 0, heightType: "common", name: "Withdraw" }
    },
    {
      path: "/ngAddAccount",
      name: "ngAddAccount",
      component: () => import("@/components/NgWithdraw/AddCard"),
      meta: { layoutLv: 1, heightType: "common", name: "Bank" }
    },
    {
      path: "/ngChooseAccount",
      name: "ngChooseAccount",
      component: () => import("@/components/NgWithdraw/HasCard"),
      meta: { layoutLv: 1, heightType: "common", name: "Bank" }
    },
    {
      path: "/nameVerify",
      name: "nameVerify",
      component: () => import("@/components/NgWithdraw/NameVerify"),
      meta: { layoutLv: 1, heightType: "common", name: "Name Verification" }
    },
    {
      path: "/birthVerify",
      name: "birthVerify",
      component: () => import("@/components/NgWithdraw/BirthVerify"),
      meta: {
        layoutLv: 0,
        heightType: "common",
        name: "Date of Birth Verification"
      }
    },
    {
      path: "/ngKYC",
      name: "ngKYC",
      component: () => import("@/components/common/ngKYC"),
      meta: {
        layoutLv: 2,
        heightType: "common",
        name: "KYC"
      }
    },
    {
      path: "/infomation",
      name: "infomation",
      component: () => import("@/components/NgWithdraw/Infomation"),
      meta: {
        layoutLv: 1,
        heightType: "common",
        name: "Information"
      }
    },
    {
      path: "/ugWithdraw",
      name: "ugWithdraw",
      component: () => import("@/components/UgWithdraw"),
      meta: { layoutLv: 0, heightType: "common", name: "Withdraw" }
    },
    {
      path: "/ghWithdraw",
      name: "ghWithdraw",
      component: () => import("@/components/GhWithdraw"),
      meta: { layoutLv: 0, heightType: "common", name: "Withdraw" }
    },
    {
      path: '/depositResult',
      name: 'depositResult',
      component: () => import('@/components/Result/Deposit/index.vue'),
      meta: {
        layoutLv: 0,
        name: 'Deposit'
      }
    },
    {
      path: '/withdrawResult',
      name: 'withdrawResult',
      component: () => import('@/components/Result/Withdraw/index.vue'),
      meta: {
        layoutLv: 0,
        name: 'Withdraw'
      }
    },
    {
      path: "/tz",
      name: "tzDeposit",
      component: () => import("@/components/TzDeposit"),
      meta: { layoutLv: 0, heightType: "common", name: "Deposit" }
    },
    {
      path: "/tzWithdraw",
      name: "tzWithdraw",
      component: () => import("@/components/TzWithdraw"),
      meta: { layoutLv: 0, heightType: "common", name: "Withdraw" }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js